module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10790/images/guidedOnboarding-card-thumbnail.webp"